import List from './list/index.vue';
export default [
  {
    path: 'list/:type',
    name: 'myDemandList',
    component: List,
    meta: {
      title: '我的供需发布',
      breadCrumbShowIndexArr: [0, 2]
    }
  }
];
